
export const isMac = () => /Mac|iPod|iPhone|iPad/.test(navigator.platform);
export const isChrome = () => /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
export const isMobile = () => /Mobi|Android/i.test(navigator.userAgent);
